// extracted by css-extract-rspack-plugin
module.exports =  {"important":"ConsultationCallCard__important___O_F0Q"};